import React from "react";
import { Card, CardProps } from "@mui/material";
import clsx from "clsx";

interface AppCardProps extends CardProps {
    children: React.ReactNode;
    className?: string;
}

export const AppCard: React.FC<AppCardProps> = ({
    children,
    className,
    ...props
}) => {
    return (
        <Card
            {...props}
            sx={{
                boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                borderRadius: "0.3rem",
            }}
            className={clsx(
                "rounded-xl border border-gray-300 bg-white",
                "p-4",
                className
            )}
        >
            {children}
        </Card>
    );
};
